import { useState } from "react";
import { Menu } from "lucide-react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="bg-[#fefaf6] w-full">
      <header className="py-2 px-4 container mx-auto relative">
        {/* Première ligne : Logo et Image */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-2 ml-20 tablet:ml-10">
          <div className="flex flex-col justify-center items-center mb-2 md:mb-0">
            <div className="flex mobile:-ml-20 tablet:ml-0">
              <img
                src="/images/logogp.png"
                alt="Guide Pro"
                className="h-10 mobile:h-6 tablet:h-7 w-auto"
              />
            </div>
          </div>
          <div className="flex flex-col items-center mr-20 tablet:mr-10">
            {/* Image du ministère */}
            <img
              src="/images/armoirie-transp.png"
              alt="armoirie"
              className="w-[75px] h-auto mb-1"
            />
            <p className="text-center leading-[1.0] text-[10px]">
              MINISTERE DE LA FONCTION <br />
              PUBLIQUE ET DE LA MODERNISATION <br />
              DE L'ADMINISTRATION
            </p>
          </div>
        </div>

        {/* Bouton menu burger mobile et tablette uniquement */}
        <button
          className="hidden md:hidden mobile:block tablet:block absolute top-4 right-4 p-2 bg-orange-500 text-white rounded"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <Menu size={20} />
        </button>

        {/* Deuxième ligne : Menu et Bouton */}
        <div
          className={`flex flex-col md:flex-row justify-between items-center ${
            menuOpen ? "flex" : "hidden md:flex"
          }`}
        >
          {/* Menu de navigation */}
          <div className="flex space-x-1 mb-2 md:mb-0 mobile:w-full tablet:w-full mobile:mb-2 tablet:mb-2 ml-20 mobile:ml-0 tablet:ml-0">
            {/* Bouton Accès Plateforme */}
            <a
              href="/login"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-sm text-xs font-semibold mobile:w-full tablet:w-full mobile:text-center tablet:text-center mr-20 mobile:mr-0 tablet:mr-0"
            >
              ACCÉDER À LA PLATEFORME
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}
